// import dashboard from './dashboard';
import contractManagement from './contractManagement';
import spendAnalytics from './spendAnalytics';
// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    items: [contractManagement, spendAnalytics]
};

export default menuItems;
